<!-- AdditionalTextBadge.vue -->
<script lang="ts" setup>
    import { computed } from 'vue';
    import { AdditionalFreeTextIndicatorType } from '../../../../lib/Api/CoverMyMeds';
    import { DisplayStyle, IconTypes } from '../../../../Enums/UiEnums';
    import Icon from '../../../../components/Icon.vue';

    const props = defineProps<{
        type?: AdditionalFreeTextIndicatorType
    }>();

    const emit = defineEmits<{
        click: [evt: MouseEvent]
    }>();    

    const additionalTextInfo = computed<AdditionalTextInfo|undefined>(()=>{
        switch(props.type)
        {
            case AdditionalFreeTextIndicatorType.Mandatory:
                return {name: "Mandatory", displayStyle: DisplayStyle.Danger, toolTip: "Mandatory Additional Text" };
            case AdditionalFreeTextIndicatorType.Optional:
                return {name: "Optional", displayStyle: DisplayStyle.Info, toolTip: "Optional Additional Text" };
        }
    });

    interface AdditionalTextInfo
    {
        name: string,
        displayStyle: DisplayStyle,
        toolTip: string
    }


</script>

<template>
    <span class="me-1">
        <Icon 
            v-if="additionalTextInfo"
            :icon="IconTypes.Edit" 
            :title="additionalTextInfo?.toolTip"
            :displayStyle="additionalTextInfo?.displayStyle"
            @click="e => emit('click', e)" />
    </span>

</template>